import {
  Button,
  Card,
  Flex,
  Grid,
  TextField,
} from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";
import { AddCircleOutline } from "@mui/icons-material";

import LabelRequired from "components/utils/LabelRequired";

const NameValueForm = ({ title, values, onChange }) => {
  const addInput = () => {
    onChange([
      ...values,
      {
        name: "",
        value: ""
      },
    ]);
  };

  const removeInput = (index) => {
    const listUpdated = [...values];
    listUpdated.splice(index, 1);
    onChange(listUpdated);
  };

  const onChangeInput = (index, name, value) => {
    const listUpdated = [...values];
    listUpdated[index] = {
      ...listUpdated[index],
      [name]: value,
    };
    onChange(listUpdated);
  };

  return (
    <>
      <Flex alignItems="center">
        <div className="fs-5">{title}</div>
        <div style={styles.iconAction} onClick={addInput}>
          <AddCircleOutline color="action" />
        </div>
      </Flex>

      {values?.length > 0 && (
        <Grid rowGap="15px" templateColumns={{ base: "1fr" }}>
          {values?.map((item, index) => {
            return (
              <Card
                height="fit-content"
                borderRadius="medium"
                variation="outlined"
              >
                <Grid columnGap="15px" rowGap="15px">
                  <Grid
                    columnGap="15px"
                    rowGap="15px"
                    templateColumns={{ base: "1fr", large: "2fr 2fr" }}
                  >
                    <TextField
                      name="name"
                      label={<LabelRequired text={strings.fields.name.label} />}
                      value={item.name}
                      onChange={(event) =>
                        onChangeInput(index, "name", event.target.value)
                      }
                    ></TextField>
                    <TextField
                      name="value"
                      label={
                        <LabelRequired text={strings.fields.value.label} />
                      }
                      value={item.value}
                      onChange={(event) =>
                        onChangeInput(index, "value", event.target.value)
                      }
                    ></TextField>
                  </Grid>
                </Grid>
                <Button
                  size="small"
                  style={styles.buttonDelete}
                  children={strings.fields.buttons.delete}
                  colorTheme="error"
                  onClick={() => removeInput(index)}
                />
              </Card>
            );
          })}
        </Grid>
      )}
    </>
  );
};

const styles = {
  iconAction: {
    marginLeft: "-5px",
    marginTop: "5px",
    cursor: "pointer",
  },
  buttonDelete: {
    float: "right",
    marginTop: "15px",
  },
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: {
        label: "Nombre",
        placeholder: "Ingrese nombre",
      },
      value: {
        label: "Valor",
        placeholder: "Ingrese valor",
      },
      buttons: {
        delete: "Eliminar",
      },
    },
  },
});

export default NameValueForm;
